import { Alert, AlertDescription } from '@design-system';
import { Info } from 'lucide-react';

export function AssetCareApplicationUnavailableAlert({ message }: { message: string | null }) {
  if (!message) return null;

  return (
    <Alert
      variant="warning"
      className="p-3"
    >
      <Info />
      <AlertDescription>{message}</AlertDescription>
    </Alert>
  );
}
